import { render, staticRenderFns } from "./BirthdaysOfMonth.vue?vue&type=template&id=9b1f6950&scoped=true"
import script from "./BirthdaysOfMonth.vue?vue&type=script&lang=js"
export * from "./BirthdaysOfMonth.vue?vue&type=script&lang=js"
import style0 from "./BirthdaysOfMonth.vue?vue&type=style&index=0&id=9b1f6950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1f6950",
  null
  
)

export default component.exports